



















































import { CardHydro } from '@/app/components';
import { useFilters } from '@/app/composable';
import { useAsset } from '@/modules/asset/composable/asset';
import { Asset } from '@/modules/asset/types';
import { EyeIcon } from '@vue-hero-icons/outline';
import { CalendarIcon, UserIcon } from '@vue-hero-icons/solid';
import { PropType, computed, defineComponent } from '@vue/composition-api';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import AssetDetails from './AssetDetails.vue';

dayjs.extend(minMax);

export default defineComponent({
    name: 'AssetCard',
    components: {
        EyeIcon,
        UserIcon,
        CalendarIcon,
        AssetDetails,
        CardHydro,
    },
    props: {
        asset: {
            type: Object as PropType<Asset>,
            required: true,
        },
        activePendingContracts: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const updatedDate = computed(() =>
            props.asset.modifiedAt
                ? dayjs.max([dayjs(props.asset.modifiedAt), dayjs(props.asset.updatedAt)]).toString()
                : props.asset.updatedAt,
        );

        const { formatDate } = useFilters();

        const { assetTypeClass, assetTypeName } = useAsset();

        return {
            assetTypeClass,
            assetTypeName,
            formatDate,
            updatedDate,
        };
    },
});
